import { onMessage } from "firebase/messaging";
import { useEffect, useState } from "react";
import { messaging } from "../../firebaseConfig";
import FeedbackDialog from "../feedback-dialog";

export default function PushNotificationManager() {
    const [feedBackSessionId, setFeedBackSessionId] = useState(null);

    const handleNotificationClick = (data) => {
        switch (data?.type) {
            case 'session.feedback':
                setFeedBackSessionId(data.sessionId);
                break;
            case 'call.ring':
                break;
            default:
                break;
        }
    }


    useEffect(() => {
        if (!messaging) return null;

        const unsubscribe = onMessage(messaging, ({ data, ...props }) => {
            if (data.type === 'call.ring') return;
        
            const notification = new Notification(data.title, {
                body: data.message,
            });
        
            notification.onclick = () => handleNotificationClick(data);
        });

        if (navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener('message', (event) => handleNotificationClick(event.data));
        }

        return () => {
            unsubscribe();
        };
    }, []);

    return (
        <>
            <FeedbackDialog sessionId={feedBackSessionId} onClose={() => setFeedBackSessionId(null)} />
        </>
    );
};